import { UserOutlined } from '@ant-design/icons'
import UserIcon from '@assets/CustomIcons/user_edited.svg'
import { UpdateStatusDrawer } from '@components/OrderDispatch/OrderGrid/OrderUpdatedTag'
import { formatters } from '@utils/intl/dateTimeFormatters'
import { Avatar, Col, Popover, Row } from 'antd'
import moment from 'moment'
import React from 'react'

export const Updated = ({ data, ignoreCreatedIfNull = true }) => {
  return (
    <Popover
      title='Request History'
      content={<UpdateStatusDrawer order={data} ignoreCreatedIfNull={ignoreCreatedIfNull} />}
      trigger='hover'
    >
      <Row className='order-stat-tag-container' style={{ flexWrap: 'nowrap' }}>
        <Col className='vertical-flex-center'>
          <Avatar
            size={24}
            style={{
              background: 'var(--theme-color-2-dim)',
              color: 'var(--theme-color-1)',
              border: '1px solid var(--gray-300)',
            }}
          >
            <UserOutlined />
          </Avatar>
        </Col>
        <Col flex={1} className=' pl-3 pr-4  vertical-flex-center h-100'>
          <div style={{ fontWeight: data?.updated_date ? 'bold' : 'normal' }}>
            {formatters.SHORT_DATE_TIME(moment(data?.updated_date ? data.updated_date : data?.created_date))}
          </div>
        </Col>
      </Row>
    </Popover>
  )
}
